import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isProdEnv } from '../utils/errorUtils';
import { initAnalyticsServices, trackAnalyticsPageView } from '../utils/analyticsServices';

function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!isProdEnv) {
      return;
    }

    initAnalyticsServices();
    trackAnalyticsPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}

export default GoogleAnalytics;
